import apiRequestService from '@/commonProject/service/apiRequestService';

export default class SuerveyRepository {
    /**
     * アンケートフォーム取得APIをコールする。
     * @param {Object} queryParam
     * @returns result
     */
    async getSuerveyFormActionApi(API_URL, queryParam, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/quefrm', queryParam, idToken);
        return result;
    }
    /**
     * アンケートフォーム登録APIをコールする。
     * @param {Object} requestBody
     * @returns result
     */
    async putSuerveyFormActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPut(API_URL + '/quefrm', requestBody, idToken);
        return result;
    }
}
